<script setup lang="ts">
import { BrandLogo } from '#layers/assets/public';
import { useOrgSummary } from '#layers/global-settings/composables/use-org-summary';

const { orgSettings, orgName, memberCount } = useOrgSummary();
</script>

<template>
	<div class="flex items-center gap-3">
		<BrandLogo :logo-id="orgSettings?.logoId" :color="orgSettings?.color" size="sm" class="shrink-0" />

		<div class="flex min-w-0 flex-col">
			<span class="truncate text-sm font-semibold text-default">{{ orgName }}</span>
			<span v-if="memberCount !== undefined" class="text-xs text-muted">{{ $t('common.members_count', { n: memberCount }) }}</span>
		</div>
	</div>
</template>
